import { Controller } from "@hotwired/stimulus";
import { renderStreamMessage } from "@hotwired/turbo";

export default class extends Controller {
  update(event) {
    // 空いている座席情報を取得するためのURLを生成
    const seat_row_id = event.target.value;
    const slug = event.target.getAttribute("data-slug");
    const seat_list_id = event.target.getAttribute("data-seat-list-id");
    const current_idx = event.target.getAttribute("data-current-idx");
    const url = `/e/${slug}/seat_lists/${seat_list_id}/vacants?seat_row=${seat_row_id}&current_idx=${current_idx}`;

    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => response.text())
      .then((html) => renderStreamMessage(html));
  }
}
